import { render, staticRenderFns } from "./InfoCoberturaAplicada.vue?vue&type=template&id=492bd573&"
import script from "./InfoCoberturaAplicada.vue?vue&type=script&lang=js&"
export * from "./InfoCoberturaAplicada.vue?vue&type=script&lang=js&"
import style0 from "./InfoCoberturaAplicada.vue?vue&type=style&index=0&id=492bd573&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports